export type TFeedbackFormFieldsName =
  | "id"
  | "status"
  | "feedbackSubjectId"
  | "driver_behavior_score"
  | "vehicle_cleaning_score"
  | "message"
  | "supplierResponse"
  | "feedbackSolutionId"
  | "adminRemarks"
  | "createdUser"
  | "reporter"
  | "rideId"
  | "createdAt"
  | "metadata.remarks"
  | "metadata.tags";

export const FeedbackFormFields = {
  id: "id",
  status: "status",
  feedbackSubjectId: "feedbackSubjectId",
  driver_behavior_score: "driver_behavior_score",
  vehicle_cleaning_score: "vehicle_cleaning_score",
  message: "message",
  supplierResponse: "supplierResponse",
  feedbackSolutionId: "feedbackSolutionId",
  adminRemarks: "adminRemarks",
  createdUser: "createdUser",
  createdAt: "createdAt",
  reporter: "reporter",
  rideId: "rideId",
  remarks: "metadata.remarks",
  tags: "metadata.tags",
} as const satisfies Record<string, TFeedbackFormFieldsName>;

export enum FeedbackQuestionType {
  rate = "rate",
  yesOrNo = "yesOrNo",
  open = "open",
}

export interface IFeedbackQuestionDef {
  key: string;
  type: FeedbackQuestionType;
}

export const FEEDBACK_QUESTION_DEFINITIONS: IFeedbackQuestionDef[] = [
  { key: "overallRideExperience", type: FeedbackQuestionType.rate },
  { key: "rideSupportService", type: FeedbackQuestionType.rate },
  { key: "recommendToColleagues", type: FeedbackQuestionType.rate },
  { key: "appEaseOfUse", type: FeedbackQuestionType.rate },
  { key: "appReliability", type: FeedbackQuestionType.rate },
  { key: "pickupLocationConvenience", type: FeedbackQuestionType.rate },
  { key: "rideRouteEfficiency", type: FeedbackQuestionType.rate },
  { key: "pickupOnTime", type: FeedbackQuestionType.rate },
  { key: "destinationOnTime", type: FeedbackQuestionType.rate },
  { key: "rideSafety", type: FeedbackQuestionType.rate },
  { key: "driverCourtesy", type: FeedbackQuestionType.rate },
  { key: "driverRouteKnowledge", type: FeedbackQuestionType.rate },
  { key: "vehicleCleanliness", type: FeedbackQuestionType.rate },
  { key: "airConditioning", type: FeedbackQuestionType.rate },
  { key: "seatsAndSpace", type: FeedbackQuestionType.rate },
  { key: "vehicleIdentification", type: FeedbackQuestionType.rate },
  { key: "wasDriverLate", type: FeedbackQuestionType.yesOrNo },
  { key: "additionalComments", type: FeedbackQuestionType.open },
];
